import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { AuthService } from '../services/auth/auth.service';
import { ApiService } from '../services/api/api.service';
import { Button } from 'primeng/button';

@Component({
    standalone: false,
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

    items!: MenuItem[];

    loading: boolean = false;

    @ViewChild('menubutton') menuButton!: ElementRef;
    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;
    @ViewChild('topbarmenu') menu!: ElementRef;

    user: any;

    isSuperAdmin: any;
    isAdmin: any;
    isEditor: any;
    isReader: any;

    currentCompany: any;
    currentOrganisation: any;

    @Output() showDialogCompanies = new EventEmitter<boolean>();
    @Output() showDialogOrganisations = new EventEmitter<boolean>();

    constructor(public layoutService: LayoutService, private authService: AuthService, private apiService: ApiService) {
        this.getCurrentUser();

        this.apiService.currentCompanyChange.subscribe((company) => {
            this.currentCompany = company;
            this.isSuperAdmin = Number(localStorage.getItem('isSuperAdmin'));
            this.isAdmin = (localStorage.getItem('isAdmin') === "true");
            this.isEditor = (localStorage.getItem('isEditor') === "true");
            this.isReader = (localStorage.getItem('isReader') === "true");
        });

        this.apiService.currentOrganisationChange.subscribe((organisation) => {
            this.currentOrganisation = organisation;
            this.setIsSelectButtonShown();

        });

        this.loading = this.apiService.fetchingAll;
        if (!this.loading) {
            this.apiService.fetchingAllChanges.subscribe((fetching) => {
                this.loading = fetching;
            });
        }
    }



    getCurrentUser() {
        this.apiService.getMe().subscribe((data: any) => {
            this.user = data.user;

            // Pour test
            // this.user.organisations = [this.user.organisations[0]];
            // this.user.companies = [this.user.companies[7]];

            this.setIsSelectButtonShown();
        });
    }

    isSelectButtonShown = false;
    setIsSelectButtonShown() {
        if (!this.user) return;
        if (this.user.is_superadmin) this.isSelectButtonShown = true;

        if (this.user.organisations.length > 1) {
            this.isSelectButtonShown = true;
        }

        this.user.companies.forEach((company: any) => {
            if (!company.organisation_id) {
                // this.currentCompany = this.user.companies[0];
                this.isSelectButtonShown = true;
            }
        })
    }

    logout() {
        this.authService.logout();
    }

    showDialog() {
        this.showDialogCompanies.emit(true);
    }

    showDialogOrga() {
        this.showDialogOrganisations.emit(true);
    }


    theme: string = 'lara-light-indigo';

    ngOnInit() {
        this.theme = this.layoutService.config().theme;
        if (this.theme === 'lara-dark-indigo') {
            this.theme = 'lara-light-indigo';
        } else {
            this.theme = 'lara-dark-indigo';
        }
    }

    toggleDarkMode() {
        this.theme = this.layoutService.config().theme;
        if (this.theme === 'lara-light-indigo') {
            this.layoutService.config.update((state) => ({ ...state, theme: 'lara-dark-indigo', colorScheme: 'dark' }));
        } else if (this.theme === 'lara-dark-indigo') {
            this.layoutService.config.update((state) => ({ ...state, theme: 'lara-light-indigo', colorScheme: 'light' }));
        }

        localStorage.setItem('theme', this.layoutService.config().theme);

        const element = document.querySelector('html');
        element.classList.toggle('my-app-dark');
    }

}
